<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
    stage: { type: String, required: true },
    note: { type: [String, Object], default: null },
    canEdit: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
})

const emit = defineEmits(['save'])

const editing = ref(false)
const draft = ref('')

const displayNote = computed(() => {
    if (!props.note) return '--'
    if (typeof props.note === 'string') return props.note
    if (typeof props.note === 'object' && props.note.fr) return props.note.fr
    return '--'
})

function startEditing() {
    draft.value = displayNote.value === '--' ? '' : displayNote.value
    editing.value = true
}

function cancel() {
    editing.value = false
}

function save() {
    emit('save', props.stage, draft.value, () => {
        editing.value = false
    })
}
</script>

<template>
    <div class="internal-notes">
        <div class="mt-4 mb-2">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <span>Notes internes :</span>
                <button
                    v-if="canEdit && !editing"
                    type="button"
                    class="btn btn-sm btn-soft-secondary shadow-none"
                    @click.prevent="startEditing"
                >
                    <i class="ri-pencil-line align-bottom"></i> Modifier
                </button>
            </div>

            <div v-if="!editing" class="fst-italic text-body" style="white-space: pre-line">{{ displayNote }}</div>

            <div v-else>
                <textarea
                    v-model="draft"
                    class="form-control"
                    rows="4"
                    placeholder="Saisir la note interne…"
                ></textarea>
                <div class="d-flex gap-2 justify-content-end mt-2">
                    <button type="button" class="btn btn-sm btn-light" :disabled="saving" @click.prevent="cancel">Annuler</button>
                    <button type="button" class="btn btn-sm btn-secondary" :disabled="saving" @click.prevent="save">Enregistrer</button>
                </div>
            </div>
        </div>
    </div>
</template>
